import React, {Fragment, useState} from 'react';

import {ArrayUtils} from "../../../Utils";
import {ContextNodeLink} from "../ContextNodeLink";
import {useSelector} from "react-redux";

export const ContextNodesTableColumn = props => {
    const {Value, emptyMessage = '', useShortName = true} = props;
    
    const {context} = useSelector(state => state.contextState);

    if (!Value) {
        return <span>N/A</span>;
    }

    // remove things without valid contextNodeIds
    let contextNodes = ((Array.isArray(Value) ? Value : [Value]) ?? [])
        // .map((x) => x?.ContextNodeDetails ?? x?.ContextNode)
        .filter(x => x?.contextNodeId);

    // remove duplicates
    contextNodes = ArrayUtils.uniqueByKey(contextNodes, 'contextNodeId')
    
    if (!contextNodes.length && emptyMessage) {
        return <span>{emptyMessage}</span>;
    }

    const contextNodesLinks = contextNodes
        .map((contextNode, index) => {
            
                let contextNodeLinkProps = {};
            
                if (!useShortName && contextNode.hasOwnProperty('title')) {
                    contextNodeLinkProps.contextNode = contextNode
                } else if (useShortName && contextNode.hasOwnProperty('shortName')) {
                    contextNodeLinkProps.contextNode = contextNode
                } else {
                    contextNodeLinkProps.contextNodeId = contextNode.contextNodeId;   
                }
                
                if(contextNode.contextNodeId === context.contextNodeId) {
                    contextNodeLinkProps.tool = 'summary';
                }
            
                return <Fragment key={contextNode.contextNodeId}>
                    <ContextNodeLink {...contextNodeLinkProps} useShortName={useShortName}></ContextNodeLink>
                    {index < contextNodes.length - 1 ? <br/> : null}
                </Fragment>;
            }
        );

    return contextNodesLinks;
};
